import React, { Component } from "react";
import moment from "moment";
import redux from "../../common/Redux";
import api, { URL_PATH } from "../../services/API";
import Toast from "../../components/Toast";
class AddGalleryItemScreen extends Component {
  constructor(props) {
    super(props);
    this.state = { activeGalleryId: null, toast: {
      open: false,
      message: "",
      severity: "success"
    } };
  }
  componentDidMount() {
    this.setState({ activeGalleryId: this.props.match.params.id });
  }
  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    this.setState({ toast: { ...this.state.toast, open: false } });
  };
  submitForm = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    formData.append("gallery_id", this.state.activeGalleryId);

    console.log(formData);
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    const response = await api(
      this,
      "post",
      URL_PATH.createGalleryItem,
      formData,
      headers
    );
    console.log(response);

    this.showToast("Gallery Item Added Successfully", "success");
    this.props.history.goBack();
  };
  render() {
    const { activeGalleryId } = this.state;
    return (
      <div className="container">
        <h1>add galaery item screen basically form</h1>
        <form onSubmit={(e) => this.submitForm(e)}>
          <div className="form-group">
            <label htmlFor="title">Title</label>
            <input
              type="text"
              className="form-control"
              id="title"
              name="title"
              placeholder="Enter title"
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <input
              type="text"
              className="form-control"
              id="description"
              name="description"
              placeholder="Enter description"
            />
          </div>
          <div className="form-group">
            <label htmlFor="image">Image</label>
            <input
              type="file"
              className="form-control"
              id="image"
              name="file"
            />
          </div>
          <div className="form-group">
            <label htmlFor="status">Status</label>
            <select className="form-control" id="status" name="status">
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>
          <button type="submit" className="btn btn-primary mt-2">
            submit
          </button>
        </form>
        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        onClose={this.handleCloseToast}
      />
      </div>
    );
  }
}

export default redux(AddGalleryItemScreen);
